import { checkIfVideoAPIReady, videoOptions, VideoPlayer } from 'features/youtube';

let player;

const { apiSettings, aspectRatio } = videoOptions;

const ui = {
	videoThumbnails: document.querySelectorAll('.career-video-thumb')
};

const utils = {
	getDynamicVideoWidth () {

		return document.documentElement.clientWidth <= 1000 ? 700 : 900;

	},
	getDynamicVideoHeight () {

		const screenHeight = document.documentElement.clientHeight;

		if (screenHeight <= 600) {

			return 500;

		}
		if (screenHeight <= 800) {

			return 600;

		}
		if (screenHeight <= 1000) {

			return 700;

		}
		return 900;

	},
	getPlayerDimensions () {

		return {
			width: utils.getDynamicVideoWidth(),
			height: utils.getDynamicVideoHeight() * aspectRatio
		};

	},
	getModalVideoContent () {

		return '<div id="player"></div>';

	}
};

const handlers = {
	setupVideoPlayer: (e) => {

		const videoId = e.currentTarget.dataset.videoid;

		const { width, height } = utils.getPlayerDimensions();

		if (videoId) {

			$('body').lpModal({
				onInit: true,
				lpModalClass: 'lpModal--alt1 lpModal--noScroll',
				content: $(utils.getModalVideoContent()),
				width,
				height,
				openEvt: () => {

					checkIfVideoAPIReady().then(() => {

						// initialize player when modal opens
						player = VideoPlayer('player', {
							width,
							height,
							videoId,
							playerVars: apiSettings
						});

					});

				},
				closeEvt: () => {

					// destroy player when modal closes
					player.destroy();
					player = null;

				}
			});

		}

	}
};

const init = () => {

	if (ui.videoThumbnails.length) {

		ui.videoThumbnails.forEach((videoThumbnail) => videoThumbnail.addEventListener('click', handlers.setupVideoPlayer));

	}

};

init();
